import { NgModule, ModuleWithProviders } from '@angular/core';

import { SN_GOOGLE_MAP_LIBRARY, GoogleMapLibrary } from '@lib/geo/google/core';

@NgModule()
export class GoogleDrawingModule {
  public static forRoot(): ModuleWithProviders<GoogleDrawingModule> {
    return {
      ngModule: GoogleDrawingModule,
      providers: [
        {
          provide: SN_GOOGLE_MAP_LIBRARY,
          useValue: GoogleMapLibrary.Drawing,
          multi: true,
        },
      ],
    };
  }
}
